<template>
    <div v-if="additionals">
        <List
            v-if="additionals.plantaoId"
            :fields="fields"
            :plantao-faixa-etaria-id="additionals.plantaoFaixaEtariaId"
            :setor-tipo-id="enums.setorTipo.EXAMES"
            @status-changed="handleStatusChanged"
        >
            <template v-slot:custom-actions="{ item }">
                <rkm-button
                    @click="handlePedidos(item)"
                    color="primary"
                    small
                    title="Atender"
                    authorize="store-pronto-atendimento-exame-imagem"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalEvasao.open(item.id)"
                    color="danger"
                    small
                    title="Evadir"
                >
                    <rkm-icon icon="running" />
                </rkm-button>
            </template>
        </List>

        <rkm-alert color="warning" v-else>
            Não existe nenhum plantão cadastrado para este usuário.
        </rkm-alert>

        <ModalEvasao ref="ModalEvasao" />
    </div>
</template>

<script>
import { prontoAtendimentoFila } from '@/mixins'

// Mixins.
import { error, repository } from '@/mixins'

export default {
    created() {
        this.repositories.exameImagem = this.getConectaSusRepository('prontoAtendimento.exameImagem')
    },
    data: () => ({
        additionals: null,
        createRouteName: 'pronto-atendimento-exame-imagem-edit',
        repositories: {
            exameImagem: null,
        },
    }),
    methods: {
        load() {
            this.repositories.exameImagem.index()
                .then(response => {
                    this.additionals = response.data.additionals
                    this.model.currentPlantaoId = this.additionals.plantaoId
                })
                .catch(this.handleError)
        },
        handlePedidos(item) {

            this.setLoading()

            this.repositories.exameImagem.create(item.id)
                .then(() => this.answer(item))
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ error, prontoAtendimentoFila, repository ],
    mounted() {

        this.load()
    },
}
</script>


